import { AppBar } from 'react-admin'
import { Box } from '@mui/material'
import LogoWhite from '../../assets/images/logo_white.png'

export const MyAppBar = (props: any) => (
  <AppBar {...props} sx={{ backgroundColor: '#007867' }}>
    <Box flex="1">
      <img src={LogoWhite} />
    </Box>
  </AppBar>
)
